import { render, staticRenderFns } from "./BiddingCurrentBid.vue?vue&type=template&id=8c8d9a72&scoped=true"
import script from "./BiddingCurrentBid.vue?vue&type=script&lang=js"
export * from "./BiddingCurrentBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8d9a72",
  null
  
)

export default component.exports